import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "f-dropdown-curtain" }
const _hoisted_2 = {
  key: 0,
  class: "f-dropdown-curtain__search"
}
const _hoisted_3 = { class: "f-dropdown-curtain__input" }
const _hoisted_4 = { class: "f-dropdown-curtain__options" }
const _hoisted_5 = ["onClick"]

import { FormDropdownOption } from '@/types/form/form-dropdown/form-dropdown';
import {
  FormDropdownCurtainEmits,
  FormDropdownCurtainProps,
} from '@/types/form/form-dropdown/form-dropdown-curtain';
import { computed, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormDropdownCurtain',
  props: {
    loading: { type: Boolean },
    options: {},
    selectedOption: {},
    clearable: { type: Boolean },
    clearText: {}
  },
  emits: ["option-click", "clear"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;
const keywords = ref<string>();
const modalSearchEl = ref<HTMLInputElement>();
const focusSearch = () => modalSearchEl.value?.focus();
const onOptionClick = (option: FormDropdownOption, index: number) => {
  emit('option-click', option, index);
};
const onClear = () => {
  emit('clear');
};
const shownOptions = computed(() => {
  if (!keywords.value) return props.options;
  return props.options.filter((option) => {
    return new RegExp(keywords.value!, 'ig').test(option.text);
  });
});
__expose({ focusSearch });

return (_ctx: any,_cache: any) => {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.options.length > 10)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_icon, {
              name: "search",
              size: "xxs"
            }),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keywords).value = $event)),
              ref_key: "modalSearchEl",
              ref: modalSearchEl
            }, null, 512), [
              [_vModelText, keywords.value]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (__props.clearable)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['f-dropdown-curtain__option clear-option', { selected: !__props.selectedOption }]),
            onClick: onClear
          }, _toDisplayString(__props.clearText), 3))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shownOptions.value, (option, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass([
          'f-dropdown-curtain__option',
          { selected: option.value === __props.selectedOption?.value },
        ]),
          onClick: ($event: any) => (onOptionClick(option, index))
        }, _toDisplayString(option.text), 11, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})